import { Navigate } from "react-router-dom";

/** Ancienne URL — tout le flux pending est sur /PayUSDT */
export default function PaymentPending() {
  return <Navigate to="/PayUSDT" replace />;
}
